import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { I } from './Icons'

const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff9e6;
  border: 1px solid #f4da6f;
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 22px;
  font-size: 13px;
  color: #6b4b00;
`

const Ico = styled.span`
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #b5880e;
  display: flex;
`

const Sp = styled.div`
  flex: 1;
`

const Btn = styled.button`
  background: transparent;
  border: 1px solid #d9b74a;
  color: #3d2a00;
  height: 28px;
  padding: 0 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background: #f4da6f;
  }
`

const BtnPrimary = styled(Btn)`
  background: ${p => p.theme.colors.semantic.accent};
  border-color: ${p => p.theme.colors.semantic.accent};
  color: #fff;
  &:hover {
    background: ${p => p.theme.colors.semantic.accentHover};
  }
`

const WipAiReviewBanner = ({ activeRev, latestRev, onReturnToLatest, onRestore }) => (
  <Banner role="alert">
    <Ico>
      <I.warning className="ico" />
    </Ico>
    <Sp>
      You&apos;re viewing <b>Rev {activeRev.revisionNumber}</b> · {activeRev.caption} ·{' '}
      {activeRev.timeLabel}. Latest is <b>Rev {latestRev.revisionNumber}</b>.
    </Sp>
    <Btn type="button" onClick={onReturnToLatest}>
      Return to Rev {latestRev.revisionNumber}
    </Btn>
    <BtnPrimary type="button" onClick={onRestore}>
      Restore this revision
    </BtnPrimary>
  </Banner>
)

WipAiReviewBanner.propTypes = {
  activeRev: PropTypes.object.isRequired,
  latestRev: PropTypes.object.isRequired,
  onReturnToLatest: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired,
}

export default WipAiReviewBanner
